import { render, staticRenderFns } from "./Receiver.vue?vue&type=template&id=34d85cb8&scoped=true&"
import script from "./Receiver.vue?vue&type=script&lang=js&"
export * from "./Receiver.vue?vue&type=script&lang=js&"
import style0 from "./Receiver.vue?vue&type=style&index=0&id=34d85cb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d85cb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34d85cb8')) {
      api.createRecord('34d85cb8', component.options)
    } else {
      api.reload('34d85cb8', component.options)
    }
    module.hot.accept("./Receiver.vue?vue&type=template&id=34d85cb8&scoped=true&", function () {
      api.rerender('34d85cb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Invoices/NewInvoice/Receiver.vue"
export default component.exports